import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import React from 'react';
import { ORDER_STATUS } from '../../../common/constants/SharedConstants';
import _ from 'lodash';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const OrderStatusDeliveryCardComp = ({
  orderDetails,
  status,
  imageSrc,
  statusMessage,
  getTime,
  cardToFill,
  showProgressBar,
}) => {
  const { ESTIMATED_ARRIVAL, ASK_FOR_OTP } = TRANSLATE_MAPPING_KEY;
  const { SENT_TO_POS_COMPLETED } = ORDER_STATUS;
  const noOfProgressDiv = 5;
  const progressTemplate = () => {
    let card = [];
    if (cardToFill !== 0) {
      _.times(noOfProgressDiv, i => {
        card.push(
          <div
            id='progressBarContainer'
            className={`ProgressDelivery ${i + 1 <= cardToFill ? 'selectedBar' : 'Bar'}`}
            key={i}
          ></div>,
        );
      });
    }
    return card;
  };

  return (
    <div>
      <div className={`estimated-arrival estimated-arrival-refund ${status}-delivery`}>
        {translateWithI18Next(ESTIMATED_ARRIVAL)}
      </div>
      <div className='idAndTime time-delivery'>
        <div className='red'>{getTime(orderDetails?.orderTime)}</div>
      </div>
      {imageSrc && <img src={imageSrc} alt={status} />}
      {showProgressBar && <div className='progress-bar-list'>{progressTemplate()}</div>}
      <div className={`allSet allset-delivery ${status}-delivery-allSet`}>{translateWithI18Next(statusMessage)}</div>
      {status !== SENT_TO_POS_COMPLETED && (
        <>
          <div className='estimated-arrival estimated-arrival-refund driver-msg'>
            {translateWithI18Next(ASK_FOR_OTP)}
          </div>
          <div className='idAndTime time-delivery'>
            <div className='red otp'>{orderDetails?.deliveryPartner?.otp}</div>
          </div>
        </>
      )}
    </div>
  );
};
export default React.memo(OrderStatusDeliveryCardComp);
